import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

const SubmissionPopupReLogin = ({ open, countdown }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>Logout by the head authority, please login again</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Navigating to the login page in {countdown} seconds...
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default SubmissionPopupReLogin;